<template>
    <div class="drop-down-menu">
      <div
        v-click-outside="hide"
        @click="opened = !opened"
        :class="{ 'border-bottom-none': opened}"
        class="form-control form-control--bordered"
      >
        <input
          type="text"
          placeholder="Группа АШК"
          v-if="!active"
          v-model.lazy="search"
          v-debounce="delay"
        >
        <input
          v-model.lazy="search"
          v-debounce="delay"
          type="text"
          :placeholder="active.name"
          v-else
        >
  
        <span
          :class="{ rotate: opened }"
          class="form-control--arrow"
        ></span>
      </div>
  
      <ul v-if="opened" class="form-control--custom">
        <li
          @click="reset"
        >
          Не выбрано
        </li>
        <li
          v-for="(li, index) in list"
          :key="index"
          @click="select(li)"
        >
          {{ li.name }}
        </li>
        <infinite-loading @infinite="infiniteHandler">
          <span slot="no-more"></span>
          <span slot="no-results"></span>
        </infinite-loading>
      </ul>
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import ClickOutside from 'vue-click-outside';
  import { directive } from 'v-debounce'
  
  export default {
    name: 'DropDownMenuAHK',
  
    props: {
      list: {
        typeof: Array,
        required: true
      },
      active: {
        typeof: Object,
        required: false,
        default: null,
      },
    },

    components: {
      InfiniteLoading,
    },
  
    directives: {
      ClickOutside,
      debounce: directive
    },
  
    data() {
      return {
        opened: false,
        selected: '',
        search: '',
        delay: 1000,
      }
    },
  
    created() {
        if (this.active) {
            this.selected = this.list.find(l => l.id == this.active.id);
        }
    },
  
    mounted () {
      this.popupItem = this.$el
    },
  
    methods: {
      ...mapActions('groups', {
        getGroup: 'getList',
      }),
      hide() {
        this.opened = false;
      },
      reset() {
        this.selected = '';
  
        this.hide();
  
        this.$emit('reset');
      },
      select(li) {
        this.selected = li;
  
        this.hide();
  
        this.$emit('selected', li);
      },
      searching(value) {
        this.$emit('search', value);
      },
      infiniteHandler($state) {
        let count = this.list.length;
        this.getGroup().then(() => {
          if (this.list.length == count) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
      }
    },
    watch: {
      search(val) {
        this.searching(val);
      }
    }
  }
  </script>
  
<style>
.drop-down-menu input {
  width: 100%;
}
</style>